<template>
    <div class="migrol-form oil-finder">

        <div class="oil-finder__filters">
            <div class="oil-finder__filter">
                <SelectWithLabel v-model="SelectedBrand" :label="Strings['Oilfinder.PickCarBrandLabel']" :options="Brands" :searchable="true" />
            </div>
            <div class="oil-finder__filter">
                <InputWithLabel v-model="SelectedYear" :label="Strings['Oilfinder.ModelYear']" type="number" maxlength="4" rules="integer|min_value:1900|max_value:2050" />
            </div>
        </div>

        <div class="oil-finder__results" v-if="FilteredOils !== null && FilteredOils.length > 0">
            <div class="oil-finder__oil" v-for="oil in FilteredOils" :key="oil.Title">
                <h2 class="oil-finder__oil-title">{{oil.Title}}</h2>
                <div class="oil-finder__oil-columns">
                    <div><img :src="oil.ImageUrl" class="oil-finder__oil-image" :alt="oil.Title" width="310" height="595"></div>
                    <div class="oil-finder__oil-description">
                        <div class="oil-finder__oil-subtitle">{{Strings['Oilfinder.Einsatzbereich']}}</div>
                        <p class="oil-finder__oil-text" v-html="oil.Einsatzbereich"></p>
                        <div class="oil-finder__oil-subtitle">{{Strings['Oilfinder.Spezifikationen']}}</div>
                        <p class="oil-finder__oil-text" v-html="oil.Spezifikationen"></p>
                        <p class="oil-finder__oil-text" v-if="oil.JahrgangInfo != null && oil.JahrgangInfo.trim() != ''" v-html="oil.JahrgangInfo"></p>
                        <div class="oil-finder__oil-subtitle" v-if="SelectedBrand !== '0'">{{Strings['Oilfinder.Year']}}</div>
                        <p class="oil-finder__oil-text" v-html="getJahrgangInfo(oil)" v-if="SelectedBrand !== '0'"></p>
                        <div class="oil-finder__oil-subtitle">{{Strings['Oilfinder.Inhalt']}}</div>
                        <p class="oil-finder__oil-text" v-html="oil.Inhaltsmenge"></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="oil-finder__no-results" v-if="FilteredOils.length === 0">{{Strings['Oilfinder.NoResults']}}<span v-if="SelectedBrand === '0'"> {{Strings['Oilfinder.PleaseChooseBrand']}}</span></div>
    </div>

</template>

<script>
    import $ from 'jQuery';

    export default {
        data() {
            return {
                Brands: [],
                Oils: [],
                Strings: [],
                SelectedBrand: '0',
                SelectedYear: null
            }
        },
        computed: {
            FilteredOils() {
                var vm = this;

                if (vm.SelectedBrand === '0' && vm.SelectedYear && vm.SelectedYear >= 1900 && vm.SelectedYear <= 2050)
                    return []; //don't show results when only a year is selected, but no brand...

                return vm.Oils.filter(oil => {
                    return oil.Brands.some(brand => {
                        return (
                            (vm.SelectedBrand === '0' || vm.SelectedBrand === brand.Name)
                            &&
                            (
                                (!vm.SelectedYear || vm.SelectedYear < 1900 && vm.SelectedYear > 2050)
                                ||
                                (brand.Compatibilities.some(compat => {
                                    return (
                                        (compat.YearFrom === null || compat.YearFrom <= vm.SelectedYear)
                                        &&
                                        (compat.YearUntil === null || compat.YearUntil >= vm.SelectedYear)
                                    );
                                }))
                            )
                        );
                    });
                });
            }
        },
        methods: {
            getJahrgangInfo(oil) {
                var vm = this;
                var bullets = [];
                var info = '';
                oil.Brands.forEach((brand) => {
                    var hasSelectedYear = vm.SelectedYear && vm.SelectedYear >= 1900 && vm.SelectedYear <= 2050;
                    var compats = [];
                    brand.Compatibilities.forEach((compat) => {
                        if (
                            (
                                vm.SelectedBrand === '0'
                                ||
                                vm.SelectedBrand === brand.Name
                            )
                            &&
                            (
                                !hasSelectedYear
                                ||
                                (
                                    ((compat.YearFrom !== null ? compat.YearFrom : 0) <= vm.SelectedYear)
                                    &&
                                    ((compat.YearUntil !== null ? compat.YearUntil : 2050) >= vm.SelectedYear)
                                )
                            )
                        ) {
                            var text = '';
                            if (compat.YearFrom && compat.YearUntil && compat.YearFrom == compat.YearUntil)
                                text = vm.Strings['Oilfinder.ModelYear'] + ' ' + compat.YearFrom;
                            if (compat.YearFrom && compat.YearUntil)
                                text = vm.Strings['Oilfinder.ModelYears'] + ' ' + compat.YearFrom + '-' + compat.YearUntil;
                            else if (compat.YearFrom)
                                text = vm.Strings['Oilfinder.ModelYearFrom'] + ' ' + compat.YearFrom;
                            else if (compat.YearUntil)
                                text = vm.Strings['Oilfinder.ModelYearUntil'] + ' ' + compat.YearUntil;

                            compats.push(text);
                        }
                    });

                    if (compats.length > 0) {
                        bullets.push(brand.Name + ': ' + compats.join(', '));
                    }
                });

                if (bullets.length > 1) {
                    info += '<ul>';
                    info += '<li>' + bullets.join('</li><li>') + '</li>';
                    info += '</ul>';
                } else {
                    info += bullets.join('');
                }

                return info;
            }
        },
        mounted() {
            var vm = this;
            $.getJSON('/migrolapi/' + vm.language + '/oilfinder').done((data) => {
                vm.Brands = data.Brands;
                vm.Oils = data.Oils;
                vm.Strings = data.Strings;
            });
        }
    };
</script>